<template>
  <k-editor-form>
    <template v-slot:left>
      <stats :id="id"></stats>
    </template>
  </k-editor-form>
</template>

<script>
import Stats from '../Stats'
export default {
  props: ['id'],
  components: {
    Stats
  }
}
</script>
